import React from "react"

import TasksView_Column from "../../../../../../model2/column/column"
import {AggregateFunctionType} from "../../../../../../data-structures/aggregators/types"
import AggregateShellComponent from "../../../../../../gd-modules/common/aggregate/aggregate-shell"

type Props = {
    column                      : TasksView_Column
    value                       : any

    isFirstInBlock?             : boolean
    isLastInBlock?              : boolean

    onChangeAggregateFunction   : {(aggregateFunction: AggregateFunctionType): void}
}

// const debug = "FieldItemModelCalculatedSpentEstimate_AggregateCell"
const debug = false

export default function FieldItemModelCalculatedSpentEstimate_AggregateCell(props: Props) {

    const isValid   = !_.isNil(props.value) && !_.isNaN(props.value)

    let valueLabel
    let progressLine
    let progressClasses
    let showProgress
    if (isValid) {
        const value     = Math.floor(props.value)
        const excess    = value > 100
        progressLine    = excess ? Math.floor(100 * (100 / value)) : value

        showProgress    = props.column.width > 100
        progressClasses = Classes("ui5-progress in-ui5-field", {
            'excess-v2'             : excess,
            'flex-row-center-center': !showProgress
        })

        valueLabel = '{0}%'.f(value)
    }

    // get available aggregate function options for this field, if any
    const options = props.column.field?.getAggregateOptions()

    debug && console.log(debug, 'render', props.value, props.column.aggregateFunction, options)

    return (
        <AggregateShellComponent
            options                     = {options}
            noData                      = {!isValid}
            hint                        = {valueLabel}
            aggregateFunction           = {props.column.aggregateFunction as string}
            isFirstInBlock              = {!!props.isFirstInBlock}
            isLastInBlock               = {!!props.isLastInBlock}
            onChangeAggregateFunction   = {props.onChangeAggregateFunction}
        >
            {isValid &&
                <div className={progressClasses}>
                    {showProgress && (
                        <div className="progress-bg">
                            <div className="progress-line" style={{width: '{0}%'.f(progressLine)}}/>
                        </div>
                    )}

                    <div className="progress-label ui5-txt-less-important-small percentage txt-truncate">
                        {valueLabel}
                    </div>
                </div>}
        </AggregateShellComponent>
    )
}
